import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Alert } from '@mui/material';

interface RequestStatusDialogProps {
  open: boolean;
  handleClose: () => void;
  email: string;
  isSuccess: boolean;
}

export default function RequestStatusDialog({
  open,
  handleClose,
  email,
  isSuccess
}: RequestStatusDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        {isSuccess ? 'Email versendet' : 'Fehler'}
      </DialogTitle>
      <DialogContent>
        {isSuccess ? (
          <Alert severity="success">
            Falls ein Account mit der Email-Adresse <strong>{email}</strong> existiert,
            wurde eine Email mit Anweisungen zum Zurücksetzen des Passworts versendet.
            Bitte überprüfen Sie Ihr Postfach.
          </Alert>
        ) : (
          <Alert severity="error">
            Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.
          </Alert>
        )}
        <DialogContentText sx={{ mt: 2 }}>
          {isSuccess
            ? 'Der Link ist 1 Stunde gültig.'
            : 'Falls das Problem weiterhin besteht, kontaktieren Sie bitte den Support.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button onClick={handleClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}